import { t } from 'i18next';

const marksColor = '#757575';

const markStyle = {
  color: marksColor,
  height: 80,
  marginLeft: 0,
};

export const getPersonalityTestMarks = () => ({
  0: {
    style: {
      ...markStyle,
      width: 100,
      transform: 'translateX(-30%)',
    },
    label: t('test.ratingScale.stronglyDisagree'),
  },
  1: {
    style: markStyle,
    label: t('test.ratingScale.disagree'),
  },
  2: {
    style: {
      ...markStyle,
      width: 100,
    },
    label: t('test.ratingScale.slightlyDisagree'),
  },
  3: {
    style: markStyle,
    label: t('test.ratingScale.neutral'),
  },
  4: {
    style: {
      ...markStyle,
      width: 80,
    },
    label: t('test.ratingScale.slightlyAgree'),
  },
  5: {
    style: {
      ...markStyle,
      transform: 'translateX(-60%)',
    },
    label: t('test.ratingScale.agree'),
  },
  6: {
    style: {
      ...markStyle,
      width: 80,
      marginLeft: -20,
    },
    label: t('test.ratingScale.stronglyAgree'),
  },
});

export const SLIDER_LEGEND_BEAK_POINT = 660;
